import React from 'react';
import { PulseLoader } from 'react-spinners';
var selectColor = function(color) {
    switch(color){
        case 'white':
            {
                return '#fff';
            }
        default:
            {
                return '#000000';
            }
    }
};
var Loading = function(props) {
    var color = props.color, size = props.size;
    return /*#__PURE__*/ React.createElement("div", {
        className: "Loading"
    }, /*#__PURE__*/ React.createElement(PulseLoader, {
        color: selectColor(color),
        size: size
    }));
};
export default Loading;
